/**
 * App entry: mounts React, sets up React Query and Supabase client provider.
 */
import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App } from './root/App'
import './index.css'

const qc = new QueryClient()

const el = document.getElementById('root')!
createRoot(el).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
)
